import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'


export default () => <BaseDateRangeReport
  reportHeader = "Card Order Report"
  reportDownloadName = "cardOrderReport"
  apiReportName = "cardOrderReport"
/>
